import Phaser from 'phaser';
import type { BossKey } from '../types';

export function makeBoss(
  scene: Phaser.Scene,
  key: BossKey,
  x: number,
  y: number,
): Phaser.GameObjects.Container {
  const c = scene.add.container(x, y);
  // Prefer AI sprite if loaded.
  const spriteKey = `boss_${key}`;
  if (scene.textures.exists(spriteKey)) {
    const s = scene.add.sprite(0, 0, spriteKey);
    s.setScale(0.18);
    c.add(s);
    return c;
  }
  switch (key) {
    case 'wolf': {
      c.add(scene.add.ellipse(0, 0, 160, 80, 0x6b6f78));
      c.add(scene.add.ellipse(0, 12, 100, 30, 0x3d4048));
      c.add(scene.add.circle(50, -20, 38, 0x6b6f78));
      c.add(scene.add.triangle(36, -50, 0, 0, -10, 14, 6, 14, 0x6b6f78));
      c.add(scene.add.triangle(60, -50, 0, 0, -10, 14, 6, 14, 0x6b6f78));
      c.add(scene.add.circle(56, -20, 4, 0xf2c14e));
      c.add(scene.add.triangle(72, -10, 0, 0, -8, 6, 8, 6, 0x111111));
      // legs
      c.add(scene.add.rectangle(-40, 40, 12, 30, 0x3d4048));
      c.add(scene.add.rectangle(-12, 42, 12, 30, 0x3d4048));
      c.add(scene.add.rectangle(20, 42, 12, 30, 0x3d4048));
      c.add(scene.add.rectangle(46, 40, 12, 30, 0x3d4048));
      // tail
      c.add(scene.add.triangle(-78, -8, 0, 0, -22, 12, -12, 22, 0x6b6f78));
      break;
    }
    case 'serpent': {
      // coiled body
      const g = scene.add.graphics();
      g.fillStyle(0x2c8a6a, 1);
      for (let i = 0; i < 6; i++) {
        g.fillCircle(-60 + i * 22, Math.sin(i) * 12, 26);
      }
      c.add(g);
      // head
      c.add(scene.add.ellipse(76, -8, 50, 36, 0x2c8a6a));
      c.add(scene.add.circle(94, -16, 4, 0xf2c14e));
      // forked tongue
      const tongue = scene.add.graphics();
      tongue.fillStyle(0xc23b3b, 1);
      tongue.fillTriangle(96, -2, 120, -6, 116, 0);
      tongue.fillTriangle(96, 2, 120, 6, 116, 0);
      c.add(tongue);
      break;
    }
    case 'bear': {
      c.add(scene.add.ellipse(0, 0, 200, 110, 0x6b3e1a));
      c.add(scene.add.ellipse(0, 16, 130, 40, 0x402610));
      c.add(scene.add.circle(70, -28, 50, 0x6b3e1a));
      c.add(scene.add.circle(50, -50, 16, 0x6b3e1a));
      c.add(scene.add.circle(90, -50, 16, 0x6b3e1a));
      c.add(scene.add.circle(50, -50, 6, 0x402610));
      c.add(scene.add.circle(90, -50, 6, 0x402610));
      c.add(scene.add.circle(82, -22, 4, 0xf2c14e));
      c.add(scene.add.circle(58, -22, 4, 0xf2c14e));
      c.add(scene.add.ellipse(80, -8, 18, 12, 0x402610));
      // legs
      c.add(scene.add.rectangle(-50, 56, 18, 36, 0x402610));
      c.add(scene.add.rectangle(-14, 58, 18, 36, 0x402610));
      c.add(scene.add.rectangle(20, 58, 18, 36, 0x402610));
      c.add(scene.add.rectangle(58, 56, 18, 36, 0x402610));
      break;
    }
    case 'dragon': {
      c.add(scene.add.ellipse(0, 0, 220, 110, 0xc23b3b));
      c.add(scene.add.ellipse(0, 18, 150, 36, 0x6b1a1a));
      // wings
      c.add(scene.add.triangle(-30, -50, 0, 0, -80, -60, -30, -100, 0xa12d2d));
      c.add(scene.add.triangle(30, -50, 0, 0, 80, -60, 30, -100, 0xa12d2d));
      // head + horns
      c.add(scene.add.ellipse(80, -20, 60, 44, 0xc23b3b));
      c.add(scene.add.triangle(74, -50, 0, 0, -8, -22, 6, -16, 0xf2c14e));
      c.add(scene.add.triangle(94, -50, 0, 0, -8, -22, 6, -16, 0xf2c14e));
      c.add(scene.add.circle(96, -22, 5, 0xf2c14e));
      // tail
      c.add(scene.add.triangle(-90, 0, 0, 0, -36, -10, -30, 18, 0xc23b3b));
      // legs
      c.add(scene.add.rectangle(-40, 56, 18, 32, 0x6b1a1a));
      c.add(scene.add.rectangle(40, 56, 18, 32, 0x6b1a1a));
      break;
    }
  }
  return c;
}
